import { Injectable } from '@angular/core'

const vimeoIdRegExp = /^https?:\/\/vimeo.com\/([0-9]*)/s
const vimeoUrlRegExp = /^https?:\/\/vimeo.com\//s
// Matches watch?v=, youtu.be/, embed/, v/, shorts/ and live/ URLs; the 11-character video id is group 1
const youtubeIdRegExp = /(?:youtu\.be\/|\/(?:v|embed|shorts|live)\/|\/u\/\w\/|[?&]v=)([\w-]{11})(?![\w-])/

@Injectable({
  providedIn: 'root',
})
export class VideoUtilsService {
  constructor() {}

  public isVideoUrl(url: string): boolean {
    return this.isVimeoUrl(url) || this.isYoutubeUrl(url)
  }

  public isVimeoUrl(url: string): boolean {
    return vimeoUrlRegExp.test(url)
  }

  public getVimeoVideoId(url: string): string | null {
    const match = vimeoIdRegExp.exec(url)
    return match && match.length >= 1 && match[1].length > 6 ? match[1] : null
  }

  public isYoutubeUrl(url: string): boolean {
    const youtubeRegExp = new RegExp(/((http(s)?:\/\/)?)(www\.)?((youtube\.com\/)|(youtu.be\/))[\S]+/)
    return youtubeRegExp.test(url)
  }

  public getYouTubeVideoId(url: string): string | null {
    const match = youtubeIdRegExp.exec(url)
    return match ? match[1] : null
  }
}
